import { createSelector } from 'reselect'

const getData = (state, layerName) => {
  return state.data[layerName]
}

const getMarkerLngLat = (state, layerName) => {
  return state.click.lngLat
}

export const makeGetMarker = () => {
  return createSelector(
    [getData, getMarkerLngLat],
    (data, markerLngLat) => {
      if (data && data.features && data.features.length > 0) {
        return markerLngLat
      } else {
        return null
      }
    }
  )
}



// WEBPACK FOOTER //
// ./src/selectors/markerSelector.js